import { IOrganizationListingModel, OrganizationListingModel } from "./OrganizationListingModel";

export interface IHospitalOrganizationListingModel extends IOrganizationListingModel {
    hospitalCount: number
}

export class HospitalOrganizationListingModel extends OrganizationListingModel implements IHospitalOrganizationListingModel {
    hospitalCount: number;
    constructor(params: Partial<IHospitalOrganizationListingModel>) {
        super(params);
        const {
            hospitalCount = 0
        } = params;
        this.hospitalCount = hospitalCount;
    }
}
